import { render, staticRenderFns } from "./AppProfileStepContact.vue?vue&type=template&id=e94a7070&"
import script from "./AppProfileStepContact.vue?vue&type=script&lang=ts&"
export * from "./AppProfileStepContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports